<navigation-induxtry [menus]="menus()" [user]="user" [brand]="brand" [menuBottom]="menuBottom" [pageTitles]="pageTitles()"
  [disabledTopNav]="true" [mobileSideNavPositionControl]="'end'" [menuMobile]="menuMobile()">
  <ng-container buttons-topnavbar>
    <div class="container-buttons-topnavbar">
      <app-notifications-bell></app-notifications-bell>
      <topnavbar-profile></topnavbar-profile>

      @if (hasMultipleLanguages()) {
      <div class="topnavbar-divider" aria-hidden="true"></div>

      <div class="language-switcher">
        <div class="language-switcher-item-selected">
          <p class="language-label-pt">
            PT
          </p>
        </div>

        <button type="button" class="language-switcher-button">
          <p class="language-label-en">
            EN
          </p>
        </button>
      </div>
      }
    </div>
  </ng-container>

  <ng-container buttons-topnavbar-mobile></ng-container>

  <ng-container body>
    <router-outlet></router-outlet>
  </ng-container>
</navigation-induxtry>